

<nav>
  <div class="uk-navbar-container" uk-navbar>
    <div class="uk-navbar-center">
      <span>Dot</span><span>.</span><span>CV</span>
    </div>
  </div>
</nav>



<style>
  nav{
    height: 40px;
    margin-bottom: 10px;
  }
  div.uk-navbar-container{
     padding: 10px;
  }
  span{
    font-size: 21px;
    font-weight: bold;
  }
  span:first-child{
    color: tomato;
      
  }
  span:nth-child(2){
    font-weight: bolder;
    font-size: 24px
  }
   
</style>